/* Workshop booking modal — enhanced UX
   - Sticky chip summary across all steps
   - Quick-pick date chips (this weekend / next weekend / first available)
   - Calendar with today + weekend marks, disabled past-month nav, selected-date banner
   - Time slots grouped morning/afternoon/evening with vibe + "Most popular ★"
   - Pax stepper with avatar dots + quick presets
   - Jumbo: hour cards with descriptions, second-frame upsell
   - Confirm: booking card, what-to-expect timeline, what-to-wear, tutor, optional occasion */
(function(){
  const isAR = document.documentElement.lang === 'ar';
  const T = isAR ? {
    monthsShort:['يناير','فبراير','مارس','أبريل','مايو','يونيو','يوليو','أغسطس','سبتمبر','أكتوبر','نوفمبر','ديسمبر'],
    monthsFull:['يناير','فبراير','مارس','أبريل','مايو','يونيو','يوليو','أغسطس','سبتمبر','أكتوبر','نوفمبر','ديسمبر'],
    dows:['ح','ن','ث','ر','خ','ج','س'],
    dowsFull:['الأحد','الإثنين','الثلاثاء','الأربعاء','الخميس','الجمعة','السبت'],
    dowsShort:['أحد','إثنين','ثلاثاء','أربعاء','خميس','جمعة','سبت'],
    today:'اليوم',
    confirmTitle:'احجز ورشتك',
    pickDate:'اختر تاريخاً سريعاً',
    thisWeekend:'هذا الأسبوع', nextWeekend:'الأسبوع القادم', firstAvail:'أقرب موعد',
    selectedDate:(s)=>`اخترت: ${s}`,
    morning:'صباحاً', afternoon:'بعد الظهر', evening:'مساءً',
    timeMorning:'هادئ ومريح', timeAfternoon:'الأكثر شعبية', timeEvening:'أجواء الغروب',
    duration3hr:'٣ ساعات', mostBooked:'الأكثر حجزاً',
    howMany:'كم شخصاً معك؟', howManyMin5:'كم شخصاً معك؟ (الحد الأدنى ٥)', howManyJumbo:'كم شخصاً؟',
    person:'شخص', persons:'أشخاص',
    pax:(n)=>{ if (isAR) { if (n===1) return 'شخص واحد'; if (n===2) return 'شخصان'; if (n<=10) return `${n} أشخاص`; return `${n} شخصاً`; } return `${n} pax`; },
    pax2:(a,b)=>`${a}-${b} شخص`,
    quickPick:'اختيار سريع',
    justMe:'أنا فقط', twoFriends:'موعد ٢', fourFriends:'٤ أصدقاء',
    howLong:'لكم ساعة؟', perHour:'د.أ / ساعة', hours:(h)=>`${h} ساعات`,
    hr2Desc:'جلسة سريعة', hr3Desc:'سجادة كاملة', hr4Desc:'عمل مفصّل',
    extraFrame:'+ أضف إطاراً ثانياً (٥٠٪ خصم)', extraFrameAdded:'إطار إضافي مُضاف',
    extraFrameDesc:'إطار ثانٍ بنصف السعر — مجموعتان تتفتنان جنباً إلى جنب',
    contactUs:'٤٠+ شخص؟ تواصل معنا',
    yourBooking:'حجزك', total:'الإجمالي', subtotal:'المجموع',
    privateSession:'جلسة خاصة', flatRate:'سعر ثابت للجلسة بأكملها',
    almostDone:'تقريباً انتهينا.',
    confirmHelp:'سنتواصل معك على واتساب خلال ساعة. إلغاء مجاني قبل ٤٨ ساعة.',
    confirmHelpCheckout:'ستُنقل إلى صفحة الدفع الآمنة لتأكيد حجزك ودفع قيمته.',
    whatToExpect:'ماذا تتوقع',
    whatToBring:'ماذا ترتدي', yourTutor:'مدربتك',
    exp1Title:'استقبال وجولة', exp1Desc:'تعرّف على الأستوديو + شرح سلامة',
    exp2Title:'صمّم قطعتك', exp2Desc:'اختر الألوان وارسم تصميمك',
    exp3Title:'تافت مع توجيه', exp3Desc:'إرشاد عملي طوال الجلسة',
    exp4Title:'خذها للمنزل', exp4Desc:'سجادتك جاهزة في نفس اليوم',
    wearText:'البس ملابس مريحة لا تمانع تلطّخها بنسالة الخيوط.',
    suppliedText:'كل ما تحتاجه نوفّره — إطارات، خيوط، بنادق، مرايل.',
    tutorName:'ليليا', tutorRole:'فنانة ومدربة',
    tutorQuote:'«سأرشدك في كل خطوة — المبتدئون مرحب بهم»',
    yourInfo:'معلوماتك',
    namePh:'ليلى الخوري', phonePh:'+962 79...', emailPh:'you@email.com',
    notesPh:'حساسية، مستوى مبتدئ، أفكار تصميم...',
    occasionLabel:'هل تحتفلون بمناسبة؟ (اختياري)', occasionPh:'عيد ميلاد، ذكرى، يوم تخرّج...',
    sendBooking:'أرسل طلب الحجز',
    sendBookingCheckout:'المتابعة إلى الدفع',
    proofN:(n)=>`${n} آخرون حجزوا هذا الأسبوع`,
    avgResponse:'الرد عادةً خلال ساعة',
    errMissing:'الرجاء إضافة اسمك ورقم واتساب.'
  } : {
    monthsShort:['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'],
    monthsFull:['January','February','March','April','May','June','July','August','September','October','November','December'],
    dows:['S','M','T','W','T','F','S'],
    dowsFull:['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'],
    dowsShort:['Sun','Mon','Tue','Wed','Thu','Fri','Sat'],
    today:'today',
    confirmTitle:'Book your workshop',
    pickDate:'Quick pick a date',
    thisWeekend:'This weekend', nextWeekend:'Next weekend', firstAvail:'Next available',
    selectedDate:(s)=>`You picked: ${s}`,
    morning:'Morning', afternoon:'Afternoon', evening:'Evening',
    timeMorning:'Cozy & quiet', timeAfternoon:'Most popular', timeEvening:'Golden hour',
    duration3hr:'3 hours', mostBooked:'Most booked',
    howMany:'How many of you?', howManyMin5:'How many of you? (min 5)', howManyJumbo:'How many people?',
    person:'person', persons:'people',
    pax:(n)=>`${n} ${n===1?'person':'people'}`,
    pax2:(a,b)=>`${a}–${b} pax`,
    quickPick:'Or pick a common size',
    justMe:'Just me', twoFriends:'Date / 2', fourFriends:'4 friends',
    howLong:'How long?', perHour:'JOD / hour', hours:(h)=>`${h} hours`,
    hr2Desc:'Quick session', hr3Desc:'Full-size rug', hr4Desc:'Detailed piece',
    extraFrame:'+ Add a second frame (50% off)', extraFrameAdded:'Extra frame added',
    extraFrameDesc:'A second frame at half price — two groups tuft side by side',
    contactUs:'40+ people? Contact us',
    yourBooking:'Your booking', total:'Total', subtotal:'Subtotal',
    privateSession:'Private session', flatRate:'Flat rate for the whole session',
    almostDone:'Almost done.',
    confirmHelp:"We'll WhatsApp you within an hour to confirm. Free cancellation up to 48 h before.",
    confirmHelpCheckout:"You'll be taken to secure checkout to confirm and pay for your booking.",
    whatToExpect:'What to expect',
    whatToBring:'What to wear', yourTutor:'Your tutor',
    exp1Title:'Welcome & tour', exp1Desc:'Studio walk-through + safety brief',
    exp2Title:'Design your piece', exp2Desc:'Pick colors and sketch your design',
    exp3Title:'Tuft with guidance', exp3Desc:'Hands-on coaching all session',
    exp4Title:'Take it home', exp4Desc:'Finished rug, same day',
    wearText:"Wear comfy clothes you don't mind getting yarn fluff on.",
    suppliedText:'Everything else is on us — frames, yarn, guns, aprons.',
    tutorName:'Lylia', tutorRole:'Lead artist & instructor',
    tutorQuote:'"I’ll walk you through every step — beginners welcome."',
    yourInfo:'Your details',
    namePh:'Layla Khoury', phonePh:'+962 79...', emailPh:'you@email.com',
    notesPh:'Allergies, beginner level, design ideas...',
    occasionLabel:'Celebrating something? (optional)', occasionPh:'Birthday, anniversary, grad day...',
    sendBooking:'Send booking request',
    sendBookingCheckout:'Continue to checkout',
    proofN:(n)=>`${n} others booked this week`,
    avgResponse:'Usually replies within an hour',
    errMissing:'Please add your name and WhatsApp.'
  };

  const STATE = {
    svc: null, svcName: '', basePrice: 35, step: 1,
    size: '50',         // '25' | '50' | '100' — default 50 cm standard
    cal: { y: 2026, m: 4 },
    date: null, time: null,
    seats: 2,
    paxRange: null, hours: 3, extraFrame: false,
    name:'', phone:'', email:'', notes:'', occasion:'', beginners: true
  };

  // ============== SIZE CATALOG ==============
  // Each rug size sets: price/pax, duration, min/max pax, physical constraints
  const SIZES = {
    '25':  { label: isAR ? '٢٥×٢٥ سم' : '25×25 cm',
             audience: isAR ? 'أطفال ٦+ سنوات' : 'Kids · age 6+',
             pricePerPax: 20, durationLabel: isAR ? '١–٢ ساعة' : '1–2 hr', durationISO: 'PT2H', durationHours: 2,
             paxPerFrame: 1, minPax: 1, maxPax: 8,
             hint: isAR ? 'إطار صغير، قص وصمغ في نفس اليوم' : 'Small frame — cut, glue, take home same day' },
    '50':  { label: isAR ? '٥٠×٥٠ سم' : '50×50 cm',
             audience: isAR ? 'كلاسيكي · للجميع' : 'Classic · everyone',
             pricePerPax: 35, durationLabel: isAR ? '٣–٤ ساعات' : '3–4 hr', durationISO: 'PT3H', durationHours: 3,
             paxPerFrame: 1, minPax: 1, maxPax: 15,
             hint: isAR ? 'الأكثر شعبية · مناسب للمبتدئين' : 'Most popular · beginner-friendly',
             popular: true },
    '100': { label: isAR ? '١×١ م' : '1 × 1 m',
             audience: isAR ? 'زوج أو تافتر متقدم' : 'Couple or advanced tufter',
             pricePerFrame: 65, pricePerPax: 0, // flat per frame — 1 solo or 2 sharing = same price
             durationLabel: isAR ? '٥ ساعات' : '5 hr', durationISO: 'PT5H', durationHours: 5,
             paxPerFrame: 2, minPax: 1, maxPax: 2,  // capped at 2 — "FOR 2" per menu
             badge: isAR ? 'لشخصين' : 'FOR 2',
             hint: isAR ? 'زوجان يتشاركان الإطار، أو شخص واحد يريد سجادة أكبر' : 'Two people share the frame, or one advanced tufter tackles a bigger rug' }
  };
  const SIZE_KEYS = ['25', '50', '100'];

  const JUMBO_TIERS = [
    { label: T.pax2(1,10),  min: 1,  max: 10 },
    { label: T.pax2(10,20), min: 10, max: 20 },
    { label: T.pax2(20,30), min: 20, max: 30 },
    { label: T.pax2(30,40), min: 30, max: 40 }
  ];
  const JUMBO_HOURLY = 125;

  // ============== CAPACITY RULES ==============
  // Studio can host 15 tufters at once (shared gun pool — classic, mini, couple).
  // Jumbo runs on its own dedicated frame and is spatially separate — doesn't count.
  const STUDIO_CAPACITY = 15;
  // Only show a "X left" warning once seats are genuinely getting scarce —
  // showing it for every minor reduction (e.g. "14 left") is just noise.
  const LOW_SEATS_THRESHOLD = 6;

  // Per-service rules. min/max pax come from the SIZE catalog for workshop.
  const SERVICE_RULES = {
    workshop: { unit: 'per-person', exclusive: false, sharesPool: true,  minSpend: 0   },
    jumbo:    { unit: 'per-hour',   exclusive: false, sharesPool: false, minSpend: 0, min: 1, max: 40 }
  };

  // ============== REAL BACKEND INTEGRATION ==============
  // Replaces the old FAKE_BOOKINGS/FAKE_AVAIL mock data with live capacity
  // from the shop-system booking backend. See shop-system's
  // api/public/availability + api/public/bookings routes and
  // lib/booking-slots.ts for the server-side half of this.
  const BOOKING_API_BASE = window.TJ_BOOKING_API_BASE || 'https://tuftjo.app';

  // Maps this modal's svc + rug size to the real backend's workshop_types
  // slug. "event" (Birthdays & Events) always books against the same
  // exclusive/custom-priced type regardless of which size is picked.
  const WORKSHOP_SLUGS = {
    workshop: { '25': 'frame_25cm', '50': 'standard', '100': 'couple_frame' }
  };
  function resolveSlug() {
    if (STATE.svc === 'jumbo') return 'jumbo';
    const bySize = WORKSHOP_SLUGS[STATE.svc] || WORKSHOP_SLUGS.workshop;
    return bySize[STATE.size] || 'standard';
  }

  // slug -> { map: Map<'y-m-d-HH:MM', {available, capacity, session_id, starts_at}>, to: <ms> }
  const AVAIL_CACHE = {};
  let availFetchToken = 0;
  let availabilityFailed = false; // true while the last availability fetch failed and nothing is cached

  function slotMapKey(y, m, d, timeStr) {
    return `${y}-${m}-${d}-${timeStr.split(' – ')[0]}`;
  }

  // Converts a UTC instant to its Amman-local y/m/d/HH:MM parts so it can be
  // keyed the same way STATE.date ('y-m-d', 0-indexed month) already is.
  function toAmmanParts(utcDate) {
    const parts = new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Asia/Amman', year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', hour12: false
    }).formatToParts(utcDate);
    const get = (t) => parts.find(p => p.type === t).value;
    return {
      y: parseInt(get('year'), 10),
      m: parseInt(get('month'), 10) - 1,
      d: parseInt(get('day'), 10),
      hh: get('hour'), mm: get('minute')
    };
  }

  async function ensureAvailability(slug) {
    const now = new Date();
    const from = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const to = new Date(from.getTime() + 120 * 86_400_000); // ~4 months — covers normal calendar browsing
    const cached = AVAIL_CACHE[slug];
    if (cached && cached.to >= to.getTime()) return cached.map;

    const token = ++availFetchToken;
    try {
      const url = `${BOOKING_API_BASE}/api/public/availability?workshop_slug=${encodeURIComponent(slug)}&from=${from.toISOString()}&to=${to.toISOString()}`;
      const res = await fetch(url);
      if (!res.ok) throw new Error(`availability ${res.status}`);
      const data = await res.json();
      if (token !== availFetchToken) return (AVAIL_CACHE[slug] || {}).map; // superseded by a newer fetch
      const map = new Map();
      (data.sessions || []).forEach(s => {
        const { y, m, d, hh, mm } = toAmmanParts(new Date(s.starts_at));
        map.set(`${y}-${m}-${d}-${hh}:${mm}`, {
          available: s.available, capacity: s.capacity, session_id: s.session_id, starts_at: s.starts_at
        });
      });
      AVAIL_CACHE[slug] = { map, to: to.getTime() };
      availabilityFailed = false;
      return map;
    } catch (e) {
      console.error('Tuft.jo: availability fetch failed', e);
      // Fail closed: with no real data every slot would read as 15 free seats.
      if (!(AVAIL_CACHE[slug] || {}).map) availabilityFailed = true;
      return (AVAIL_CACHE[slug] || {}).map || new Map();
    }
  }

  function refreshAvailabilityAndRerender() {
    ensureAvailability(resolveSlug()).then(() => {
      renderCalendar();
      renderSlots();
    });
  }

  // Asia/Amman has no DST (confirmed by the backend's own SHOP_TIMEZONE
  // comment) — a fixed UTC+3 offset, so wall-clock-to-UTC is simple
  // subtraction rather than needing a full timezone library in the theme.
  function ammanWallClockToUtcIso(y, m, d, timeStr) {
    const [hh, mm] = timeStr.split(' – ')[0].split(':').map(Number);
    return new Date(Date.UTC(y, m, d, hh - 3, mm)).toISOString();
  }

  // Human-readable Amman-local label for the same wall-clock time
  // ammanWallClockToUtcIso converts — shown on the order/line item instead
  // of (or alongside) the raw UTC ISO string, which is easy to misread as
  // the actual booked hour (e.g. "16:00:00.000Z" is really 7pm in Amman).
  const AMMAN_MONTH_NAMES = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
  function ammanWallClockLabel(y, m, d, timeStr) {
    const [hh, mm] = timeStr.split(' – ')[0].split(':').map(Number);
    const period = hh >= 12 ? 'PM' : 'AM';
    const hour12 = ((hh + 11) % 12) + 1;
    const mmStr = String(mm).padStart(2, '0');
    return `${AMMAN_MONTH_NAMES[m - 1]} ${d}, ${y}, ${hour12}:${mmStr} ${period} (Amman time)`;
  }

  // Creates the real tentative/shopify-channel booking in shop-system.
  // Fire-and-forget from the caller's perspective — never blocks or breaks
  // the existing WhatsApp flow if this fails (offline, backend down, etc).
  function submitRealBooking({ name, phone, email, notes, occasion, beginners, total }) {
    if (!STATE.date || !STATE.time) return;
    const [y, m, d] = STATE.date.split('-').map(Number);
    const startsAt = ammanWallClockToUtcIso(y, m, d, STATE.time);
    const slug = resolveSlug();

    let seats;
    let extraNotes = notes;
    if (STATE.svc === 'jumbo') {
      const tier = JUMBO_TIERS[STATE.paxRange];
      seats = tier ? tier.min : 1;
      const tierNote = `Group size: ${tier ? tier.label : '?'} · ${STATE.hours}h` + (STATE.extraFrame ? ' · +1 extra frame' : '');
      extraNotes = [tierNote, notes].filter(Boolean).join(' — ');
    } else {
      seats = STATE.seats;
    }
    if (occasion) extraNotes = [extraNotes, `Occasion: ${occasion}`].filter(Boolean).join(' — ');
    if (beginners) extraNotes = [extraNotes, 'First time tufting'].filter(Boolean).join(' — ');

    fetch(`${BOOKING_API_BASE}/api/public/bookings`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        workshop_slug: slug,
        starts_at: startsAt,
        seats,
        // Only jumbo's duration is customer-chosen — everything else has a
        // fixed duration_hours server-side and ignores this field.
        hours: STATE.svc === 'jumbo' ? STATE.hours : undefined,
        customer_name: name,
        customer_phone: phone,
        customer_email: email || undefined,
        notes: extraNotes || undefined
      })
    }).then(res => res.json()).then(data => {
      if (!data || !data.ok) {
        console.error('Tuft.jo: booking API rejected the request', data && data.error);
      }
    }).catch(err => {
      console.error('Tuft.jo: booking API request failed', err);
    });
  }

  // Shopify product handles for the workshop types that have a fixed price
  // (seats × price, or a flat per-frame price) and so can go straight to a
  // real Shopify checkout instead of a WhatsApp quote. Jumbo isn't here —
  // its price depends on customer-chosen hours plus an optional 50%-off
  // extra frame, which doesn't reduce to one fixed-price variant, so it
  // stays on the WhatsApp inquiry flow below.
  const WORKSHOP_PRODUCT_HANDLES = {
    frame_25cm: 'workshop-mini-tufting',
    standard: 'workshop-classic-tufting',
    couple_frame: 'workshop-couple-tufting'
  };

  // Adds the selected workshop session to the real Shopify cart (as hidden
  // line item properties the shop-system webhook reads to create a
  // confirmed booking once the order is paid — see
  // lib/shopify/workshop-booking.ts) and sends the customer straight to
  // checkout. Returns true if this path was taken; false means the caller
  // should fall back to the WhatsApp flow (Jumbo, or if the request failed).
  async function addWorkshopToCartAndCheckout({ notes, occasion, beginners, name, phone, email }) {
    const slug = resolveSlug();
    const handle = WORKSHOP_PRODUCT_HANDLES[slug];
    if (!handle || !STATE.date || !STATE.time) return false;

    const [y, m, d] = STATE.date.split('-').map(Number);
    const startsAtIso = ammanWallClockToUtcIso(y, m, d, STATE.time);
    const startsAtLabel = ammanWallClockLabel(y, m, d, STATE.time);
    const sz = SIZES[STATE.size];
    // Per-frame types (Couple) charge per frame, not per pax — cart quantity
    // must match what the variant's price is actually priced against.
    const quantity = sz && sz.pricePerFrame ? Math.ceil(STATE.seats / sz.paxPerFrame) : STATE.seats;

    let extraNotes = notes;
    if (occasion) extraNotes = [extraNotes, `Occasion: ${occasion}`].filter(Boolean).join(' — ');
    if (beginners) extraNotes = [extraNotes, 'First time tufting'].filter(Boolean).join(' — ');

    try {
      const productRes = await fetch(`/products/${handle}.js`);
      if (!productRes.ok) throw new Error(`product fetch ${productRes.status}`);
      const product = await productRes.json();
      const variant = product.variants && product.variants[0];
      if (!variant) throw new Error('no variant on workshop product');

      const addRes = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{
            id: variant.id,
            quantity,
            properties: {
              '_workshop_slug': slug,
              '_workshop_starts_at': startsAtIso,
              '_workshop_seats': STATE.seats,
              '_workshop_notes': extraNotes || '',
              'Session time': startsAtLabel
            }
          }]
        })
      });
      if (!addRes.ok) throw new Error(`cart add ${addRes.status}`);

      // Pre-fill Shopify checkout's Contact/Billing fields with what this
      // modal already collected, so the customer isn't asked to retype
      // their name/email/phone a second time — checkout still shows its
      // own Contact section (that's a fixed part of standard, non-Plus
      // Shopify checkout and can't be removed), but at least it arrives
      // already filled in instead of empty.
      //
      // Workshop variants are all requires_shipping:false (they're a
      // service, not a shipped good), so this checkout only ever collects a
      // *billing* address, never a shipping one — prefilling
      // checkout[shipping_address][...] here is a silent no-op for exactly
      // that reason (confirmed live: fields stayed blank). billing_address
      // is the one that actually renders. shipping_address is set too,
      // harmless, in case a future workshop product ever does ship.
      const nameParts = (name || '').trim().split(/\s+/);
      const firstName = nameParts[0] || '';
      const lastName = nameParts.slice(1).join(' ');
      const checkoutParams = new URLSearchParams();
      if (email) checkoutParams.set('checkout[email]', email);
      if (firstName) {
        checkoutParams.set('checkout[shipping_address][first_name]', firstName);
        checkoutParams.set('checkout[billing_address][first_name]', firstName);
      }
      if (lastName) {
        checkoutParams.set('checkout[shipping_address][last_name]', lastName);
        checkoutParams.set('checkout[billing_address][last_name]', lastName);
      }
      if (phone) {
        checkoutParams.set('checkout[shipping_address][phone]', phone);
        checkoutParams.set('checkout[billing_address][phone]', phone);
      }
      // A workshop booking never ships anywhere — it's redeemed in person at
      // the studio — so the billing address Shopify insists on collecting
      // for card payments is functionally meaningless here. Prefilling it
      // with the studio's own fixed address means the customer never has to
      // type anything into that section at all, instead of hand-entering a
      // home address for a service that has nothing to do with it.
      checkoutParams.set('checkout[billing_address][address1]', 'Moath Bin Jabal Street, Building 33');
      checkoutParams.set('checkout[billing_address][city]', 'Amman');
      checkoutParams.set('checkout[billing_address][country]', 'Jordan');

      window.location.href = `/checkout?${checkoutParams.toString()}`;
      return true;
    } catch (e) {
      console.error('Tuft.jo: could not add workshop booking to cart', e);
      return false;
    }
  }

  // Real remaining seats for this slot, from whatever's been fetched so far.
  // No entry yet (still loading, or nothing scheduled and not yet queried)
  // optimistically reports full capacity — the server is the real gate at
  // booking time regardless of what the UI shows here.
  function getRemainingCapacity(dateKey, timeStr) {
    if (!dateKey) return STUDIO_CAPACITY;
    const slug = resolveSlug();
    const map = (AVAIL_CACHE[slug] || {}).map;
    if (!map) return STUDIO_CAPACITY;
    const [y, m, d] = dateKey.split('-').map(Number);
    const entry = map.get(slotMapKey(y, m, d, timeStr));
    return entry ? entry.available : STUDIO_CAPACITY;
  }

  // Check if a service+pax combo is allowed at this slot. Cross-type
  // exclusivity for Birthdays & Events (blocking other workshops at the
  // same slot) is no longer simulated client-side — the real backend's
  // gun-pool check runs at actual booking time and staff review every
  // "tentative" Shopify-channel booking anyway, same safety net as before.
  function checkSlotAvailability(svc, requestedPax, dateKey, timeStr) {
    if (!dateKey || !timeStr) return { ok: true, reason: '', remaining: STUDIO_CAPACITY };
    const remaining = getRemainingCapacity(dateKey, timeStr);
    if (requestedPax > remaining) {
      return { ok: false,
        reason: isAR ? `المتوفر ${remaining} أماكن فقط.` : `Only ${remaining} seats left.`,
        remaining };
    }
    return { ok: true, reason: '', remaining };
  }

  // ============== HOURS: open every day, 11:00-23:00 ==============
  // Last bookable start for a session is set so it always finishes by
  // close — mirrors shop-system's lib/booking-slots.ts exactly (same
  // OPEN_HOUR/CLOSE_HOUR numbers), which is the real, authoritative gate.
  const OPEN_HOUR = 11;
  const CLOSE_HOUR = 23;
  // Start times are offered every 2 hours rather than every hour, matching
  // shop-system's own SLOT_STEP_HOURS (lib/booking-slots.ts) exactly — so
  // the picker isn't overwhelming and the backend never rejects a time this
  // modal offers.
  const SLOT_STEP_HOURS = 2;

  // Jumbo's duration is chosen by the customer (2/3/4h) in step 2, *after*
  // the time slot is picked in step 1 — so step 1's slot list is generated
  // using whatever STATE.hours currently is (defaults to 3, the modal's own
  // default). If they later pick a longer duration than their chosen slot
  // supports, the backend booking check is the real gate (same
  // client-optimistic/server-authoritative pattern used everywhere else in
  // this modal, e.g. getRemainingCapacity's own comment above).
  function currentDurationHours() {
    if (STATE.svc === 'jumbo') return STATE.hours || 3;
    const sz = SIZES[STATE.size];
    return sz ? sz.durationHours : 3;
  }
  function lastStartHour(durationHours) { return CLOSE_HOUR - durationHours; }

  // A slot has already started (in real Amman wall-clock time, not the
  // visitor's own timezone) — used to strip already-passed start times off
  // of today's list instead of letting someone book a session that's
  // already over. Every future date is trivially never "past" here, so this
  // only ever changes behavior for the current day.
  function isSlotPast(y, m, d, timeStr) {
    return new Date(ammanWallClockToUtcIso(y, m, d, timeStr)).getTime() <= Date.now();
  }

  // Generates this session length's bookable hourly start times as
  // "HH:00 – HH:00" strings (replaces the old fixed 3-session SLOTS list).
  function getSlots() {
    const dur = currentDurationHours();
    const last = lastStartHour(dur);
    const out = [];
    for (let h = OPEN_HOUR; h <= last; h += SLOT_STEP_HOURS) {
      const time = `${String(h).padStart(2,'0')}:00 – ${String(h + dur).padStart(2,'0')}:00`;
      const label = h < 14 ? T.morning : (h < 18 ? T.afternoon : T.evening);
      out.push({ time, label, popular: h === 14 });
    }
    return out;
  }

  // Derives a calendar day's status ('closed' | 'full' | 'few' | 'open')
  // from real fetched availability instead of a deterministic fake pattern.
  // Before data has loaded for a given slug, optimistically reports 'open'
  // for any day that isn't in the past — refreshAvailabilityAndRerender()
  // repaints once the real fetch resolves. Open every day now (no Mon/Tue
  // closure).
  function dayStatus(y, m, d) {
    const today = new Date();
    const todayStart = new Date(today.getFullYear(), today.getMonth(), today.getDate());
    const dt = new Date(y, m, d);
    if (dt < todayStart) return 'closed';
    const times = getSlots().map(s => s.time.split(' – ')[0]).filter(t => !isSlotPast(y, m, d, t));
    // Every start time today has already gone by — same as a fully-booked
    // day: nothing left to offer, so "Next available" rolls to tomorrow.
    if (times.length === 0) return 'full';
    const map = (AVAIL_CACHE[resolveSlug()] || {}).map;
    if (!map) return 'open';
    let anyOpen = false, anyLow = false, sawAny = false;
    times.forEach(t => {
      const entry = map.get(`${y}-${m}-${d}-${t}`);
      if (!entry) { anyOpen = true; return; } // not yet scheduled — auto-create-on-demand means it's still bookable
      sawAny = true;
      if (entry.available > 0) {
        anyOpen = true;
        if (entry.capacity > 0 && entry.available <= Math.max(1, Math.floor(entry.capacity * 0.25))) anyLow = true;
      }
    });
    if (!anyOpen) return 'full';
    return (sawAny && anyLow) ? 'few' : 'open';
  }

  // A returning customer already told us their name/WhatsApp/email once —
  // remembering it locally means they only ever type it the first time on
  // this device/browser, and every booking after that opens pre-filled.
  // Best-effort: private browsing or a blocked storage API just means no
  // memory, never a broken modal.
  const CONTACT_STORAGE_KEY = 'tuftjo_ws_contact';
  function loadSavedContact() {
    try {
      const raw = localStorage.getItem(CONTACT_STORAGE_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch { return null; }
  }
  function saveContact(name, phone, email) {
    try {
      localStorage.setItem(CONTACT_STORAGE_KEY, JSON.stringify({ name, phone, email }));
    } catch { /* ignore — best effort only */ }
  }

  // ============== OPEN / NAV ==============
  // presetSize ('25' | '50' | '100') locks the card to one rug size — used by
  // the Mini/Classic/Couple experience cards, each of which is really just
  // the 'workshop' flow pre-pointed at one SIZES entry so all the existing
  // capacity/pricing/checkout-handle logic (keyed off STATE.size) works
  // unchanged. Cards with no preset (jumbo) keep the old picker behavior.
  function openModal(svc, svcName, price, presetSize) {
    STATE.svc = svc;
    STATE.svcName = svcName;
    STATE.basePrice = parseInt(price, 10);
    STATE.date = null;
    STATE.time = null;
    STATE.size = presetSize || '50'; // default: 50cm standard rug
    STATE.sizeLocked = !!presetSize && svc !== 'jumbo';
    if (svc === 'workshop') STATE.seats = 2;
    else if (svc === 'jumbo') { STATE.paxRange = 0; STATE.hours = 3; STATE.extraFrame = false; }
    STATE.name = ''; STATE.phone = ''; STATE.email = ''; STATE.notes = ''; STATE.occasion = ''; STATE.beginners = true;

    // Pre-fill Name/WhatsApp/Email from a previous booking on this device,
    // if any — the customer already gave us this once, so they shouldn't
    // have to retype it on every visit.
    const saved = loadSavedContact();
    if (saved) {
      STATE.name = saved.name || '';
      STATE.phone = saved.phone || '';
      STATE.email = saved.email || '';
    }
    const nameEl = document.getElementById('wsName');
    const phoneEl = document.getElementById('wsPhone');
    const emailEl = document.getElementById('wsEmail');
    if (nameEl) nameEl.value = STATE.name;
    if (phoneEl) phoneEl.value = STATE.phone;
    if (emailEl) emailEl.value = STATE.email;

    const today = new Date();
    STATE.cal = { y: today.getFullYear(), m: today.getMonth() };

    document.getElementById('wsServiceTitle').textContent = svcName;

    ensureChipsContainer();
    ensureQuickPicks();

    goTo(1);
    ensureSizePicker();  // inject size picker DOM if not present
    renderSizePicker();  // populate it based on current STATE.size
    renderCalendar();
    renderSlots(); // shows empty hint until a date is picked
    refreshAvailabilityAndRerender(); // fetch real capacity, repaints calendar/slots once loaded
    document.getElementById('wsModal').classList.add('open');
    document.body.style.overflow = 'hidden';
  }

  // ============== SIZE PICKER (step 1, above the calendar) ==============
  function ensureSizePicker() {
    const step1 = document.querySelector('.ws-step[data-step="1"]');
    if (!step1) return;
    // Jumbo has no size picker (it's one product); neither do the
    // Mini/Classic/Couple cards, which arrive with the size already locked.
    let picker = document.getElementById('wsSizePicker');
    if (STATE.svc === 'jumbo' || STATE.sizeLocked) {
      if (picker) picker.remove();
      return;
    }
    if (picker) return;
    picker = document.createElement('div');
    picker.id = 'wsSizePicker';
    picker.className = 'ws-size-picker';
    // Inject right after the H3/help header (or at the top of step1 if no anchor)
    const help = step1.querySelector('.ws-help');
    if (help && help.nextSibling) step1.insertBefore(picker, help.nextSibling);
    else step1.insertBefore(picker, step1.firstChild);
  }

  function renderSizePicker() {
    const picker = document.getElementById('wsSizePicker');
    if (!picker) return;

    const cardsHtml = SIZE_KEYS.map(k => {
      const s = SIZES[k];
      const on = STATE.size === k ? ' on' : '';
      const star = s.popular ? '<span class="ws-size-star">★</span>' : '';
      // Per-frame vs per-pax price display
      const priceText = s.pricePerFrame
        ? `JOD ${s.pricePerFrame}${isAR?'/إطار':'/frame'}`
        : `JOD ${s.pricePerPax}${isAR?'/شخص':'/pax'}`;
      const frameNote = k === '100'
        ? `<span class="ws-size-note">${isAR ? 'حتى ٢ شخص · نفس السعر' : `Up to ${s.paxPerFrame} pax · same price`}</span>`
        : '';
      return `<button type="button" class="ws-size-card${on}" data-size="${k}">
        <div class="ws-size-head"><b>${s.label}</b>${star}</div>
        <div class="ws-size-aud">${s.audience}</div>
        <div class="ws-size-meta">
          <span class="ws-size-price">${priceText}</span>
          <span class="ws-size-dur">${s.durationLabel}</span>
        </div>
        ${frameNote}
      </button>`;
    }).join('');

    const heading = isAR ? 'اختر مقاس السجادة' : 'Pick a rug size';

    picker.innerHTML = `
      <div class="ws-size-label">${heading}</div>
      <div class="ws-size-grid">${cardsHtml}</div>
    `;

    picker.querySelectorAll('.ws-size-card').forEach(btn => {
      btn.addEventListener('click', () => {
        STATE.size = btn.dataset.size;
        const s = SIZES[STATE.size];
        STATE.basePrice = s.pricePerPax;
        // Reset time (durations differ per size) so user re-picks
        STATE.time = null;
        // Clamp seats to new size's min/max
        if (STATE.seats < s.minPax) STATE.seats = s.minPax;
        if (STATE.seats > s.maxPax) STATE.seats = s.maxPax;
        renderSizePicker();
        renderSlots();
        renderChipSummary();
        refreshAvailabilityAndRerender(); // size change = different workshop_type slug, needs its own capacity data
        const nb = document.getElementById('wsNext');
        if (nb && STATE.step === 1) nb.disabled = !(STATE.date && STATE.time);
      });
    });
  }

  function closeModal() {
    document.getElementById('wsModal').classList.remove('open');
    document.body.style.overflow = '';
  }

  function goTo(step) {
    STATE.step = step;
    document.querySelectorAll('.ws-step').forEach(s => s.classList.toggle('on', parseInt(s.dataset.step,10) === step));
    document.querySelectorAll('.ws-step-dot').forEach(d => {
      const n = parseInt(d.dataset.step,10);
      d.classList.toggle('on', n === step);
      d.classList.toggle('done', n < step);
    });

    const back = document.getElementById('wsBack');
    const next = document.getElementById('wsNext');
    back.disabled = step === 1;

    if (step === 3) {
      // Confirm step (last)
      next.style.display = 'none';
      renderConfirmPage();
    } else {
      next.style.display = '';
      // Step 1 needs BOTH date AND time to advance (combined screen)
      next.disabled = (step === 1 && (!STATE.date || !STATE.time));
    }

    renderChipSummary();
    const panel = document.querySelector('.ws-panel');
    if (panel) panel.scrollTop = 0;
  }

  // ============== CHIP SUMMARY (sticky) ==============
  function ensureChipsContainer() {
    if (document.getElementById('wsChips')) return;
    const progress = document.querySelector('.ws-progress');
    const chips = document.createElement('div');
    chips.id = 'wsChips';
    chips.className = 'ws-chips';
    progress.parentNode.insertBefore(chips, progress.nextSibling);
  }

  function renderChipSummary() {
    const c = document.getElementById('wsChips');
    if (!c) return;
    if (!STATE.date) { c.innerHTML = ''; c.classList.remove('on'); return; }

    const [y,m,d] = STATE.date.split('-').map(Number);
    const dt = new Date(y, m, d);
    const dateLabel = `${T.dowsShort[dt.getDay()]} ${d} ${T.monthsShort[m]}`;

    let html = '';

    // Size chip (workshop + event only — jumbo has no size)
    if (STATE.svc !== 'jumbo' && SIZES[STATE.size]) {
      const sizeLabel = SIZES[STATE.size].label;
      html += `<button type="button" class="ws-chip" data-jump="1" title="${isAR?'تعديل المقاس':'Change size'}">
        <svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><rect x="4" y="4" width="16" height="16" rx="1.5"/><path d="M4 9h16M9 4v16"/></svg>
        <span>${sizeLabel}</span>
      </button>`;
    }

    html += `<button type="button" class="ws-chip" data-jump="1" title="${isAR?'تعديل التاريخ':'Change date'}">
      <svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><rect x="3" y="5" width="18" height="16" rx="2"/><line x1="3" y1="10" x2="21" y2="10"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="16" y1="2" x2="16" y2="6"/></svg>
      <span>${dateLabel}</span>
    </button>`;

    if (STATE.time) {
      const justTime = STATE.time.split(' – ')[0];
      html += `<button type="button" class="ws-chip" data-jump="1" title="${isAR?'تعديل الوقت':'Change time'}">
        <svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><circle cx="12" cy="12" r="9"/><polyline points="12 7 12 12 15 14"/></svg>
        <span>${justTime}</span>
      </button>`;
    }

    if (STATE.step >= 2) {
      let paxLabel = '';
      if (STATE.svc === 'jumbo') {
        paxLabel = `${JUMBO_TIERS[STATE.paxRange || 0].label} · ${STATE.hours}h`;
      } else {
        const unit = STATE.size === '25' ? (isAR?'أطفال':'kids') : (STATE.seats===1?T.person:T.persons);
        paxLabel = `${STATE.seats} ${unit}`;
      }
      html += `<button type="button" class="ws-chip" data-jump="2" title="${isAR?'تعديل العدد':'Change people'}">
        <svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><circle cx="9" cy="8" r="3.5"/><circle cx="17" cy="9" r="3"/><path d="M2 20c0-3 3-5 7-5s7 2 7 5"/><path d="M22 20c0-2.5-2-4.2-5-4.5"/></svg>
        <span>${paxLabel}</span>
      </button>`;

      const total = calcTotal();
      html += `<div class="ws-chip-price">JOD ${total}</div>`;
    }

    c.innerHTML = html;
    c.classList.add('on');
    c.querySelectorAll('.ws-chip[data-jump]').forEach(b => {
      b.addEventListener('click', () => {
        const target = parseInt(b.dataset.jump, 10);
        if (target === 2) renderSeats();
        goTo(target);
      });
    });
  }

  // ============== STEP 1: QUICK PICKS + CALENDAR ==============
  function ensureQuickPicks() {
    const step1 = document.querySelector('.ws-step[data-step="1"]');
    if (!step1 || document.getElementById('wsQuickPicks')) return;
    const calCol = step1.querySelector('.ws-cal-col') || step1;
    const calHead = calCol.querySelector('.ws-cal-head');
    const picks = document.createElement('div');
    picks.id = 'wsQuickPicks';
    picks.className = 'ws-quickpicks';
    calCol.insertBefore(picks, calHead);
  }

  function renderQuickPicks() {
    const w = document.getElementById('wsQuickPicks');
    if (!w) return;

    const today = new Date();
    today.setHours(0,0,0,0);

    // "This weekend" — next Saturday (or today if Sat)
    const thisWeekend = (() => {
      const dt = new Date(today);
      const dow = dt.getDay();
      const daysUntilSat = (6 - dow + 7) % 7;
      if (daysUntilSat === 0 && dow === 6) return dt;
      dt.setDate(dt.getDate() + daysUntilSat);
      return dt;
    })();
    const nextWeekend = new Date(thisWeekend);
    nextWeekend.setDate(nextWeekend.getDate() + 7);

    // First available = first non-closed/non-full from today
    const firstAvail = (() => {
      const dt = new Date(today);
      for (let i = 0; i < 60; i++) {
        const st = dayStatus(dt.getFullYear(), dt.getMonth(), dt.getDate());
        if (st === 'open' || st === 'few') return new Date(dt);
        dt.setDate(dt.getDate() + 1);
      }
      return null;
    })();

    const fmt = (dt) => `${T.dowsShort[dt.getDay()]} ${dt.getDate()} ${T.monthsShort[dt.getMonth()]}`;

    let html = `<div class="ws-qp-label">${T.pickDate}</div><div class="ws-qp-row">`;

    const addChip = (label, dt, star) => {
      const st = dayStatus(dt.getFullYear(), dt.getMonth(), dt.getDate());
      if (!st || st === 'closed' || st === 'full') return '';
      const key = `${dt.getFullYear()}-${dt.getMonth()}-${dt.getDate()}`;
      const cls = star ? 'ws-qp ws-qp-star' : 'ws-qp';
      const isToday = dt.getTime() === today.getTime();
      const lab = isToday ? T.today : fmt(dt);
      return `<button type="button" class="${cls}" data-d="${key}" data-y="${dt.getFullYear()}" data-m="${dt.getMonth()}">
        <b>${star?'★ ':''}${label}</b>
        <span>${lab}</span>
      </button>`;
    };

    if (firstAvail) html += addChip(T.firstAvail, firstAvail, true);
    html += addChip(T.thisWeekend, thisWeekend, false);
    html += addChip(T.nextWeekend, nextWeekend, false);

    html += `</div>`;
    w.innerHTML = html;

    w.querySelectorAll('.ws-qp').forEach(b => {
      b.addEventListener('click', () => {
        STATE.date = b.dataset.d;
        STATE.time = null;
        STATE.cal = { y: parseInt(b.dataset.y,10), m: parseInt(b.dataset.m,10) };
        renderCalendar();
        renderSlots();
        const nb = document.getElementById('wsNext');
        if (nb) nb.disabled = !(STATE.date && STATE.time);
        renderChipSummary();
      });
    });
  }

  function renderCalendar() {
    const grid = document.getElementById('wsCalGrid');
    const title = document.getElementById('wsCalTitle');
    const { y, m } = STATE.cal;
    title.textContent = `${T.monthsFull[m]} ${y}`;

    // Header — Sun first to match getDay(); mark Fri/Sat as weekend in Jordan
    let html = T.dows.map((d,i) => `<div class="dow ${i===5||i===6?'we':''}">${d}</div>`).join('');

    const first = new Date(y, m, 1);
    const firstDow = first.getDay();  // 0=Sun
    for (let i = 0; i < firstDow; i++) html += `<div class="day muted"></div>`;

    const days = new Date(y, m+1, 0).getDate();
    const today = new Date();
    const todayStart = new Date(today.getFullYear(), today.getMonth(), today.getDate());

    for (let d = 1; d <= days; d++) {
      const dt = new Date(y, m, d);
      const key = `${y}-${m}-${d}`;
      const status = dayStatus(y, m, d);
      const sel = STATE.date === key ? ' on' : '';
      const isToday = dt.getTime() === todayStart.getTime();
      const todayCls = isToday ? ' today' : '';
      const dow = dt.getDay();
      const weekendCls = (dow === 5 || dow === 6) ? ' weekend' : ''; // Fri/Sat = JO weekend
      const disabled = (status === 'closed' || status === 'full') ? 'disabled' : '';
      html += `<button type="button" class="day ${status}${sel}${todayCls}${weekendCls}" data-key="${key}" ${disabled}>${d}</button>`;
    }
    grid.innerHTML = html;

    grid.querySelectorAll('.day').forEach(d => {
      d.addEventListener('click', () => {
        if (d.classList.contains('closed') || d.classList.contains('full') || d.classList.contains('muted')) return;
        STATE.date = d.dataset.key;
        // Reset time if changing date so they re-pick a slot for the new day
        STATE.time = null;
        renderCalendar();
        renderSlots(); // populate right column live
        // Step 1 (combined) needs both date AND time before Next becomes enabled
        const nb = document.getElementById('wsNext');
        if (nb) nb.disabled = !(STATE.date && STATE.time);
        renderChipSummary();
      });
    });

    // Disable prev nav if current month
    const prevBtn = document.getElementById('wsCalPrev');
    const nowM = today.getMonth(), nowY = today.getFullYear();
    prevBtn.disabled = (y < nowY) || (y === nowY && m <= nowM);

    renderQuickPicks();
    renderSelectedDateBanner();
  }

  function renderSelectedDateBanner() {
    let banner = document.getElementById('wsDateBanner');
    if (!STATE.date) { if (banner) banner.remove(); return; }
    if (!banner) {
      banner = document.createElement('div');
      banner.id = 'wsDateBanner';
      banner.className = 'ws-date-banner';
      const key = document.querySelector('.ws-cal-key');
      key.parentNode.insertBefore(banner, key.nextSibling);
    }
    const [y,m,d] = STATE.date.split('-').map(Number);
    const dt = new Date(y, m, d);
    const lab = `${T.dowsFull[dt.getDay()]}, ${d} ${T.monthsFull[m]}`;
    banner.innerHTML = `<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12l5 5L20 7"/></svg><span>${T.selectedDate(lab)}</span>`;
  }

  // ============== STEP 1 (right column): TIME SLOTS as vertical pills ==============
  function renderSlots() {
    const slots = document.getElementById('wsSlots');
    const sub   = document.getElementById('wsTimeDate');

    // No date yet → show the empty hint
    if (!STATE.date) {
      if (sub) sub.textContent = isAR ? 'اختر تاريخاً أولاً' : 'Select a date first';
      slots.classList.remove('has-date');
      slots.innerHTML = `<div class="ws-slots-empty">📅 ${isAR ? 'اختر تاريخاً<br/>لرؤية الأوقات المتاحة' : 'Select a date<br/>to see available times'}</div>`;
      return;
    }

    if (availabilityFailed) {
      const wa = 'https://wa.me/962791322281?text=' + encodeURIComponent(isAR ? 'مرحباً، أود حجز ورشة' : "Hi! I'd like to book a workshop");
      slots.classList.remove('has-date');
      slots.innerHTML = `<div class="ws-slots-empty">⚠️ ${isAR ? 'تعذّر تحميل المواعيد المتاحة' : "Couldn't load available times"}<br/><a href="${wa}" target="_blank" rel="noopener">${isAR ? 'راسلنا على واتساب لحجز موعدك' : 'WhatsApp us to book your slot'}</a></div>`;
      STATE.time = null;
      const nb = document.getElementById('wsNext');
      if (nb && STATE.step === 1) nb.disabled = true;
      return;
    }

    const [y,m,d] = STATE.date.split('-').map(Number);
    const dt = new Date(y, m, d);
    const dateShort = `${T.dowsShort[dt.getDay()]}, ${d} ${T.monthsShort[m]}`;
    if (sub) sub.textContent = dateShort;

    // Compose slot state from real fetched availability (see ensureAvailability above)
    const rule = SERVICE_RULES[STATE.svc] || SERVICE_RULES.workshop;
    // Min pax = the size's minPax for workshop/event, or rule.min for jumbo
    const sizeCfg = SIZES[STATE.size];
    const minRequestedPax = (STATE.svc === 'jumbo') ? rule.min : (sizeCfg ? sizeCfg.minPax : 1);
    const durationLabel = (STATE.svc === 'jumbo') ? T.hours(currentDurationHours()) : (sizeCfg ? sizeCfg.durationLabel : T.duration3hr);

    const slotState = getSlots()
      .filter(s => !isSlotPast(y, m, d, s.time))
      .map(s => {
        const avail = checkSlotAvailability(STATE.svc, minRequestedPax, STATE.date, s.time);
        const remaining = avail.remaining;
        return { ...s, available: avail.ok, blockReason: avail.reason, remaining, durationLabel };
      });

    if (slotState.length === 0) {
      slots.classList.remove('has-date');
      slots.innerHTML = `<div class="ws-slots-empty">📅 ${isAR ? 'لا مزيد من الجلسات اليوم<br/>اختر تاريخاً آخر' : 'No more sessions today<br/>pick another date'}</div>`;
      STATE.time = null;
      const nextBtn = document.getElementById('wsNext');
      if (nextBtn && STATE.step === 1) nextBtn.disabled = true;
      return;
    }

    slots.classList.add('has-date');
    slots.innerHTML = slotState.map(s => {
      const sel = STATE.time === s.time ? ' on' : '';
      const disabled = !s.available;
      const disabledCls = disabled ? ' full' : '';
      const popular = s.popular ? `<span class="ws-slot-pop">★</span>` : '';
      const startTime = s.time.split(' – ')[0];

      // Meta line: block reason if unavailable, "X seats left" if filling, otherwise duration
      let metaLine;
      if (disabled) {
        metaLine = s.blockReason;
      } else if (rule.sharesPool && s.remaining <= LOW_SEATS_THRESHOLD) {
        const seatsLabel = isAR ? `${s.remaining} أماكن` : `${s.remaining} left`;
        metaLine = `<span class="ws-slot-cap">${seatsLabel}</span>`;
      } else {
        metaLine = s.durationLabel;
      }

      return `<button type="button" class="ws-slot${sel}${disabledCls}" data-time="${s.time}" ${disabled?'disabled':''}>
        <span class="ws-slot-lead">
          <b>${startTime}</b>
          <span class="ws-slot-label">${s.label}${popular}</span>
        </span>
        <span class="ws-slot-meta">${metaLine}</span>
      </button>`;
    }).join('');

    slots.querySelectorAll('.ws-slot').forEach(el => {
      el.addEventListener('click', () => {
        if (el.classList.contains('full')) return;
        STATE.time = el.dataset.time;
        renderSlots();
        // On step 1 (combined), Next enables once BOTH date + time are set
        const nextBtn = document.getElementById('wsNext');
        if (nextBtn && STATE.step === 1) nextBtn.disabled = !(STATE.date && STATE.time);
        renderChipSummary();
      });
    });
  }

  // ============== STEP 3: PAX (stepper for group/private, tiers for jumbo) ==============
  function renderSeats() {
    const wrap = document.getElementById('wsSeats');
    const summary = document.getElementById('wsSeatsSummary');
    const step3 = document.querySelector('.ws-step[data-step="2"]');
    const h3 = step3.querySelector('h3');
    const help = step3.querySelector('.ws-help');

    if (STATE.svc === 'jumbo') {
      if (h3) h3.textContent = isAR ? 'حجم المجموعة والمدة' : 'Group size & duration';
      if (help) help.textContent = isAR ? 'إطار ضخم وسجادة مشتركة — مثالي للمناسبات والشركات.' : 'One huge frame, one shared rug — perfect for events and parties.';
      renderJumbo(wrap, summary);
    } else {
      // workshop
      const sz = SIZES[STATE.size];
      if (h3) h3.textContent = isAR ? 'كم شخصاً معك؟' : 'How many of you?';
      if (help) help.textContent = isAR
        ? `مقاس ${sz.label} · ${sz.hint}`
        : `${sz.label} · ${sz.hint}`;
      renderStepper(wrap, summary, sz.minPax, sz.maxPax, 'workshop');
    }

    document.getElementById('wsNext').disabled = false;
    renderChipSummary();
  }

  function renderStepper(wrap, summary, min, max, svcType) {
    const sz = SIZES[STATE.size];

    // If a date+time is selected, cap max at remaining capacity for that slot
    let capacityNote = '';
    if (STATE.date && STATE.time && SERVICE_RULES[svcType] && SERVICE_RULES[svcType].sharesPool) {
      const remaining = getRemainingCapacity(STATE.date, STATE.time);
      if (remaining < max) {
        max = Math.max(min, remaining);
        capacityNote = isAR
          ? `فقط ${remaining} أماكن متاحة في هذه الجلسة`
          : `Only ${remaining} seats available in this session`;
      }
    }

    if (STATE.seats < min) STATE.seats = min;
    if (STATE.seats > max) STATE.seats = max;

    // Avatar dots — fill up to seat count, gray after
    let dots = '';
    for (let i = 1; i <= max; i++) {
      dots += `<span class="ws-dot ${i <= STATE.seats ? 'on' : ''}"></span>`;
    }

    // Presets tailored to the size (25 kids → 1..8, 50 standard → 1/2/4/6/10, 100 → 1/2 for solo/couple)
    let presets;
    if (STATE.size === '25') {
      presets = [{n:1,lab:'1'},{n:2,lab:'2',pop:true},{n:3,lab:'3'},{n:4,lab:'4'},{n:6,lab:'6'},{n:8,lab:'8'}];
    } else if (STATE.size === '100') {
      presets = [
        {n:1,lab:isAR?'أنا فقط':'Solo'},
        {n:2,lab:isAR?'زوجان':'Couple',pop:true},
        {n:4,lab:'4'},{n:6,lab:'6'},{n:8,lab:'8'},{n:10,lab:'10'}
      ];
    } else {
      presets = [{n:1,lab:T.justMe},{n:2,lab:T.twoFriends,pop:true},{n:4,lab:T.fourFriends},{n:6,lab:'6'},{n:10,lab:'10'},{n:13,lab:'13'}];
    }
    presets = presets.filter(p => p.n >= min && p.n <= max);

    const presetsHtml = presets.map(p => {
      const on = STATE.seats === p.n ? ' on' : '';
      const popMark = p.pop ? ' <span class="pop">★</span>' : '';
      return `<button type="button" class="ws-qp-pax${on}" data-n="${p.n}">${p.lab}${popMark}</button>`;
    }).join('');

    // Unit label — kids on 25cm say "kids", everything else says "person/people"
    let unit;
    if (STATE.size === '25') {
      unit = STATE.seats === 1 ? (isAR?'طفل':'kid') : (isAR?'أطفال':'kids');
    } else {
      unit = STATE.seats === 1 ? T.person : T.persons;
    }

    // For 1×1 shared frames, tell them how many rugs they'll get
    let framesNote = '';
    if (STATE.size === '100' && sz.paxPerFrame > 1) {
      const rugs = Math.ceil(STATE.seats / sz.paxPerFrame);
      framesNote = `<div class="ws-frames-note">${isAR ? `= ${rugs} إطار مشترك` : `= ${rugs} shared rug${rugs>1?'s':''}`}</div>`;
    }

    wrap.innerHTML = `
      <div class="ws-stepper-wrap">
        <div class="ws-stepper">
          <button type="button" class="ws-stepper-btn" id="wsPaxMinus" ${STATE.seats <= min ? 'disabled' : ''} aria-label="−">−</button>
          <div class="ws-stepper-val">
            <b>${STATE.seats}</b>
            <span>${unit}</span>
          </div>
          <button type="button" class="ws-stepper-btn" id="wsPaxPlus" ${STATE.seats >= max ? 'disabled' : ''} aria-label="+">+</button>
        </div>
        <div class="ws-dots">${dots}</div>
        ${framesNote}
        ${capacityNote ? `<div class="ws-cap-note">⚠ ${capacityNote}</div>` : ''}
        <div class="ws-qp-pax-label">${T.quickPick}</div>
        <div class="ws-qp-pax-row">${presetsHtml}</div>
      </div>
    `;

    document.getElementById('wsPaxMinus').addEventListener('click', () => {
      if (STATE.seats > min) { STATE.seats--; renderSeats(); }
    });
    document.getElementById('wsPaxPlus').addEventListener('click', () => {
      if (STATE.seats < max) { STATE.seats++; renderSeats(); }
    });
    wrap.querySelectorAll('.ws-qp-pax').forEach(b => {
      b.addEventListener('click', () => {
        STATE.seats = parseInt(b.dataset.n, 10);
        renderSeats();
      });
    });

    // Summary — per-pax OR per-frame
    let subtotal, breakdownLine;
    if (sz.pricePerFrame) {
      const frames = Math.ceil(STATE.seats / sz.paxPerFrame);
      subtotal = frames * sz.pricePerFrame;
      const rugLbl = isAR ? (frames === 1 ? 'إطار' : 'إطارات') : (frames === 1 ? 'rug' : 'rugs');
      breakdownLine = `${STATE.seats} ${isAR ? 'شخص' : 'pax'} · ${frames} ${rugLbl} × JOD ${sz.pricePerFrame} · ${sz.label}`;
    } else {
      subtotal = STATE.seats * sz.pricePerPax;
      const perLabel = STATE.size === '25' ? (isAR?'/ طفل':'/ kid') : (isAR?'/ شخص':'/ pax');
      breakdownLine = `${STATE.seats} × JOD ${sz.pricePerPax} ${perLabel} · ${sz.label}`;
    }
    const total = subtotal;
    summary.innerHTML = `
      <div class="ws-sum-line"><span>${breakdownLine}</span><b>JOD ${subtotal}</b></div>
      <div class="ws-sum-total"><span>${T.total}</span><b>JOD ${total}</b></div>`;
  }

  function renderJumbo(wrap, summary) {
    const tierHtml = JUMBO_TIERS.map((t, i) => {
      const sel = STATE.paxRange === i ? ' on' : '';
      const popMark = i === 0 ? ' <span class="pop">★</span>' : '';
      return `<button type="button" class="ws-tier${sel}" data-tier="${i}">${t.label}${popMark}</button>`;
    }).join('');

    const hrInfo = { 2: T.hr2Desc, 3: T.hr3Desc, 4: T.hr4Desc };
    const hrHtml = [2,3,4].map(h => {
      const sel = STATE.hours === h ? ' on' : '';
      const popMark = h === 3 ? ' <span class="pop">★</span>' : '';
      return `<button type="button" class="ws-tier ws-tier-hr${sel}" data-hrs="${h}">
        <b>${T.hours(h)}${popMark}</b>
        <span>${hrInfo[h]}</span>
      </button>`;
    }).join('');

    wrap.innerHTML = `
      <div class="ws-block-label">${T.howManyJumbo}</div>
      <div class="ws-tiers">${tierHtml}</div>
      <a class="ws-contact-link" href="https://wa.me/962791322281?text=${encodeURIComponent('Hi Tuft.jo, I have a group of 40+ and want to book the Jumbo Frame.')}" target="_blank" rel="noopener">${T.contactUs} →</a>

      <div class="ws-block-label" style="margin-top:22px">${T.howLong} <span class="ws-rate">JOD ${JUMBO_HOURLY}/${isAR?'ساعة':'hr'}</span></div>
      <div class="ws-tiers ws-tiers-3">${hrHtml}</div>

      <button type="button" class="ws-upsell ${STATE.extraFrame?'on':''}" id="wsExtraFrame">
        <span class="check">${STATE.extraFrame ? '✓' : '+'}</span>
        <div class="ws-upsell-body">
          <b>${T.extraFrame}</b>
          <span>${T.extraFrameDesc}</span>
        </div>
      </button>
    `;

    wrap.querySelectorAll('.ws-tier[data-tier]').forEach(b => b.addEventListener('click', () => {
      STATE.paxRange = parseInt(b.dataset.tier, 10);
      renderSeats();
    }));
    wrap.querySelectorAll('.ws-tier[data-hrs]').forEach(b => b.addEventListener('click', () => {
      STATE.hours = parseInt(b.dataset.hrs, 10);
      renderSeats();
    }));
    document.getElementById('wsExtraFrame').addEventListener('click', () => {
      STATE.extraFrame = !STATE.extraFrame;
      renderSeats();
    });

    const baseTotal = JUMBO_HOURLY * STATE.hours;
    const frameAdd = STATE.extraFrame ? Math.round(baseTotal * 0.5) : 0;
    const total = baseTotal + frameAdd;
    const tierLabel = JUMBO_TIERS[STATE.paxRange || 0].label;
    summary.innerHTML = `
      <div class="ws-sum-line"><span>${tierLabel} · ${T.hours(STATE.hours)}</span><b>JOD ${baseTotal}</b></div>
      ${STATE.extraFrame ? `<div class="ws-sum-line disc"><span>${T.extraFrameAdded} (50%)</span><b>+JOD ${frameAdd}</b></div>` : ''}
      <div class="ws-sum-total"><span>${T.total}</span><b>JOD ${total}</b></div>`;
  }

  // ============== STEP 4: CONFIRM (expanded with expect/wear/tutor) ==============
  function renderConfirmPage() {
    const step4 = document.querySelector('.ws-step[data-step="3"]');
    if (!step4) return;

    // Inject expanded content (what-to-expect, wear, tutor) before the form once
    let expandPanel = document.getElementById('wsExpand');
    if (!expandPanel) {
      expandPanel = document.createElement('div');
      expandPanel.id = 'wsExpand';
      expandPanel.className = 'ws-expand';
      const form = step4.querySelector('.ws-form');
      form.parentNode.insertBefore(expandPanel, form);
    }

    const goesToCheckout = !!WORKSHOP_PRODUCT_HANDLES[resolveSlug()];
    const h3 = step4.querySelector('h3');
    const help = step4.querySelector('.ws-help');
    if (h3) h3.textContent = T.almostDone;
    if (help) help.textContent = goesToCheckout ? T.confirmHelpCheckout : T.confirmHelp;

    // What-to-expect / what-to-wear / instructor blurb used to render here —
    // pure marketing filler that added scroll length to the last step right
    // before checkout with no bearing on completing the booking. Dropped
    // per explicit request to cut friction; only the form section label
    // remains.
    expandPanel.innerHTML = `
      <div class="ws-section-label">${T.yourInfo}</div>
    `;

    // Update form placeholders
    const nameInput  = document.getElementById('wsName');
    const phoneInput = document.getElementById('wsPhone');
    const emailInput = document.getElementById('wsEmail');
    const notesInput = document.getElementById('wsNotes');
    if (nameInput)  nameInput.placeholder  = T.namePh;
    if (phoneInput) phoneInput.placeholder = T.phonePh;
    if (emailInput) emailInput.placeholder = T.emailPh;
    if (notesInput) notesInput.placeholder = T.notesPh;

    // Inject occasion field once
    if (!document.getElementById('wsOccasionRow')) {
      const beginnersLabel = document.querySelector('.ws-check');
      const occ = document.createElement('label');
      occ.id = 'wsOccasionRow';
      occ.innerHTML = `<span>${T.occasionLabel}</span><input id="wsOccasion" placeholder="${T.occasionPh}"/>`;
      beginnersLabel.parentNode.insertBefore(occ, beginnersLabel);
    }

    renderConfirmSummary();

    // Update confirm button label + icon — checkout (card) icon by default,
    // swapped to the WhatsApp glyph for jumbo, the one type still on that flow.
    const confirmBtn = document.getElementById('wsConfirm');
    if (confirmBtn) {
      const svgHtml = goesToCheckout
        ? '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="6" width="18" height="14" rx="2"/><path d="M3 10h18"/><path d="M7 14h4"/></svg>'
        : '<svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12.04 2C6.58 2 2.13 6.45 2.13 11.91c0 1.75.46 3.45 1.32 4.95L2.05 22l5.25-1.38c1.45.79 3.08 1.21 4.74 1.21 5.46 0 9.91-4.45 9.91-9.91 0-2.65-1.03-5.14-2.9-7.01A9.86 9.86 0 0 0 12.04 2"/></svg>';
      confirmBtn.innerHTML = svgHtml + ' ' + (goesToCheckout ? T.sendBookingCheckout : T.sendBooking);
    }
  }

  function renderConfirmSummary() {
    const total = calcTotal();
    const [y,m,d] = STATE.date.split('-').map(Number);
    const dt = new Date(y,m,d);
    const dateLab = `${T.dowsFull[dt.getDay()]}, ${d} ${T.monthsFull[m]} ${y}`;

    let paxLine = '';
    if (STATE.svc === 'jumbo') {
      paxLine = `${JUMBO_TIERS[STATE.paxRange].label} · ${T.hours(STATE.hours)}` +
        (STATE.extraFrame ? ` · +1 ${isAR?'إطار إضافي':'extra frame'}` : '');
    } else {
      const sz = SIZES[STATE.size];
      const u = STATE.size === '25' ? (isAR?'أطفال':'kids') : (STATE.seats === 1 ? T.person : T.persons);
      paxLine = `${sz.label} · ${STATE.seats} ${u}`;
    }

    document.getElementById('wsSummary').innerHTML = `
      <div class="ws-book-card">
        <div class="ws-book-row">
          <div class="ws-book-svc">${STATE.svcName}</div>
          <div class="ws-book-total"><span>${T.total}</span><b>JOD ${total}</b></div>
        </div>
        <div class="ws-book-meta">
          <div><svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><rect x="3" y="5" width="18" height="16" rx="2"/><line x1="3" y1="10" x2="21" y2="10"/></svg><span>${dateLab}</span></div>
          <div><svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><circle cx="12" cy="12" r="9"/><polyline points="12 7 12 12 15 14"/></svg><span>${STATE.time}</span></div>
          <div><svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><circle cx="9" cy="8" r="3.5"/><circle cx="17" cy="9" r="3"/><path d="M2 20c0-3 3-5 7-5s7 2 7 5"/></svg><span>${paxLine}</span></div>
        </div>
      </div>
      <div class="ws-social-proof">
        <div class="avatars"><span>L</span><span>M</span><span>S</span></div>
        <span>${T.proofN(4)} · ${T.avgResponse}</span>
      </div>
    `;
  }

  // ============== PRICING ==============
  function calcTotal() {
    if (STATE.svc === 'jumbo') {
      const baseTotal = JUMBO_HOURLY * STATE.hours;
      return baseTotal + (STATE.extraFrame ? Math.round(baseTotal * 0.5) : 0);
    }
    // workshop or event — pricing depends on size mode:
    //   - per-pax: subtotal = seats * pricePerPax
    //   - per-frame (shared rug): subtotal = ceil(seats / paxPerFrame) * pricePerFrame
    // event has JOD 210 min spend floor
    const sz = SIZES[STATE.size] || SIZES['50'];
    let subtotal;
    if (sz.pricePerFrame) {
      const frames = Math.ceil(STATE.seats / sz.paxPerFrame);
      subtotal = frames * sz.pricePerFrame;
    } else {
      subtotal = STATE.seats * sz.pricePerPax;
    }
    const rule = SERVICE_RULES[STATE.svc] || SERVICE_RULES.workshop;
    return Math.max(subtotal, rule.minSpend || 0);
  }

  // ============== INIT ==============
  document.addEventListener('DOMContentLoaded', () => {
    const modal = document.getElementById('wsModal');
    if (!modal) return;

    // Whole card is clickable (not just the CTA button) — the button stays
    // in the DOM for a clear visual affordance and keyboard/tab focus, but
    // the click listener lives on the card so any click within it opens the
    // same modal without double-firing (only one listener, on the card).
    document.querySelectorAll('.tj-svc').forEach(card => {
      const b = card.querySelector('.tj-svc-cta[data-svc]');
      if (!b) return;
      card.addEventListener('click', () => openModal(b.dataset.svc, b.getAttribute('data-svc-name')||b.dataset.svcName, b.dataset.price, b.dataset.size || undefined));
    });
    modal.addEventListener('click', (e) => { if (e.target.dataset.close !== undefined) closeModal(); });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && modal.classList.contains('open')) closeModal(); });

    document.getElementById('wsCalPrev').addEventListener('click', () => {
      let { y, m } = STATE.cal;
      const today = new Date();
      if (y === today.getFullYear() && m <= today.getMonth()) return;
      m--; if (m<0) { m=11; y--; }
      STATE.cal = {y, m}; renderCalendar();
    });
    document.getElementById('wsCalNext').addEventListener('click', () => {
      let { y, m } = STATE.cal; m++; if (m>11) { m=0; y++; }
      STATE.cal = {y, m}; renderCalendar();
    });
    document.getElementById('wsNext').addEventListener('click', () => {
      const next = (STATE.step || 1) + 1;
      if (next === 1) { renderCalendar(); renderSlots(); }
      if (next === 2) renderSeats();
      goTo(next);
    });
    document.getElementById('wsBack').addEventListener('click', () => {
      const back = (STATE.step || 1) - 1;
      if (back === 1) { renderCalendar(); renderSlots(); }
      if (back === 2) renderSeats();
      goTo(back);
    });

    document.getElementById('wsConfirm').addEventListener('click', async () => {
      const name = document.getElementById('wsName').value.trim();
      const phone = document.getElementById('wsPhone').value.trim();
      const email = document.getElementById('wsEmail').value.trim();
      const notes = document.getElementById('wsNotes').value.trim();
      const occasion = (document.getElementById('wsOccasion')||{}).value || '';
      const beg = document.getElementById('wsBeginners').checked;
      if (!name || !phone) {
        if (window.tjToast) window.tjToast(T.errMissing, { error: true });
        else alert(T.errMissing);
        return;
      }
      saveContact(name, phone, email);

      const confirmBtn = document.getElementById('wsConfirm');

      // Classic/Mini/Couple have fixed Shopify pricing — send the customer
      // straight to real checkout instead of a WhatsApp quote. Jumbo's price
      // depends on customer-chosen hours + an optional add-on, so it isn't in
      // WORKSHOP_PRODUCT_HANDLES and addWorkshopToCartAndCheckout no-ops for
      // it — only WORKSHOP_PRODUCT_HANDLES types fall through to WhatsApp on
      // failure below; jumbo always did (that's its only booking path).
      if (WORKSHOP_PRODUCT_HANDLES[resolveSlug()]) {
        confirmBtn.disabled = true;
        const wentToCheckout = await addWorkshopToCartAndCheckout({ notes, occasion, beginners: beg, name, phone, email });
        confirmBtn.disabled = false;
        if (wentToCheckout) return;
        if (window.tjToast) window.tjToast(isAR ? 'حدث خطأ، حاول عبر واتساب' : 'Something went wrong — please try WhatsApp instead', { error: true });
        else alert('Something went wrong — please try WhatsApp instead');
        return;
      }

      const total = calcTotal();
      const dt = (() => {
        const [y,m,d] = STATE.date.split('-').map(Number);
        return `${T.dowsFull[new Date(y,m,d).getDay()]}, ${d} ${T.monthsFull[m]} ${y}`;
      })();

      const detail = `▸ Group size: ${JUMBO_TIERS[STATE.paxRange].label}\n` +
        `▸ Duration: ${T.hours(STATE.hours)}\n` +
        (STATE.extraFrame ? `▸ + 1 extra frame (50% off)\n` : '');

      const msg =
        `Hi Tuft.jo — workshop booking request:\n\n` +
        `▸ Service: ${STATE.svcName}\n` +
        `▸ Date: ${dt}\n` +
        `▸ Time: ${STATE.time}\n` +
        detail +
        `▸ Total: JOD ${total}\n` +
        (beg ? `▸ First time tufting — quick intro requested\n` : '') +
        (occasion ? `▸ Occasion: ${occasion}\n` : '') +
        (notes ? `▸ Notes: ${notes}\n` : '') +
        `\nMy details:\nName: ${name}\nPhone: ${phone}` + (email ? `\nEmail: ${email}` : '');

      // Jumbo only from here down — unchanged tentative-booking + WhatsApp flow.
      submitRealBooking({ name, phone, email, notes, occasion, beginners: beg, total });
      if (window.tjToast) window.tjToast('Opening WhatsApp...');
      setTimeout(() => window.open(`https://wa.me/962791322281?text=${encodeURIComponent(msg)}`, '_blank'), 400);
    });
  });

  window.TJ_WS_OPEN = openModal;
})();
